export const MODALS = Object.freeze({
  welcome: {
    name: 'welcome',
    component: 'WelcomeGuide'
  },
  jobRecommendationOverview: {
    name: 'jobRecommendationOverview',
    component: 'JobRecommendationOverview'
  },
  deleteSRB: {
    name: 'deleteSRB',
    component: 'DeleteSRB'
  },
  deleteJST: {
    name: 'deleteJST',
    component: 'DeleteJST'
  },
  deleteResume: {
    name: 'deleteResume',
    component: 'DeleteResume'
  },
  updateAccountSettings: {
    name: 'updateAccountSettings',
    component: 'UpdateAccountSettings'
  },
  updateLinkedinProfile: {
    name: 'updateLinkedinProfile',
    component: 'UpdateLinkedinProfile'
  },
  updatePersonalInformation: {
    name: 'updatePersonalInformation',
    component: 'UpdatePersonalInformation'
  },
  updateServiceOverview: {
    name: 'updateServiceOverview',
    component: 'UpdateServiceOverview'
  },
  updateTransitionPreferences: {
    name: 'updateTransitionPreferences',
    component: 'UpdateTransitionPreferences'
  },
  updateCivilianEducation: {
    name: 'updateCivilianEducation',
    component: 'UpdateCivilianEducation'
  },
  uploadJST: {
    name: 'uploadJST',
    component: 'UploadJST'
  },
  uploadSRB: {
    name: 'uploadSRB',
    component: 'UploadSRB'
  },
  uploadResume: {
    name: 'uploadResume',
    component: 'UploadResume'
  },
  changePassword: {
    name: 'changePassword',
    component: 'ChangePassword'
  },
  changePathwayJobRole: {
    name: 'changePathwayJobRole',
    component: 'ChangePathwayJobRole'
  },
  resetPathwayJobRole: {
    name: 'resetPathwayJobRole',
    component: 'ResetPathwayJobRole'
  },
  meToday: {
    name: 'meToday',
    component: 'MeToday'
  },
  updateOccupation: {
    name: 'updateOccupation',
    component: 'UpdateOccupation'
  },
  learningRecommendationsFilters: {
    name: 'learningRecommendationsFilters',
    component: 'LearningRecommendationsFilters'
  },
  learningProgramOverview: {
    name: 'learningProgramOverview',
    component: 'LearningProgramOverview'
  }
});

export type ModalName = keyof typeof MODALS;
